export default __webpack_public_path__ + "static/media/store_blue_icon.8a70d6c2.svg";